<script setup lang="ts">
import Clock4Icon from '@/components/Clock4Icon.vue'
import { type FrontendPathwayEvent, usePathwayEvent } from '@/composables/game/pathway-events'
import { formatDuration } from '@/helpers/date'

const props = defineProps<{
	clientDeal: FrontendPathwayEvent
}>()

const { countdownForEventEnd } = usePathwayEvent(props.clientDeal)
</script>

<template>
  <div
    class="h-[173px] rounded-2xl bg-[linear-gradient(180deg,rgba(187,170,204,1)_0%,rgba(251,231,198,0.66)_55%,rgba(208,169,245,0)_89%)] p-0.5"
  >
    <div class="rounded-2xl w-full h-full bg-dark-bottom-layer flex flex-col items-center justify-center">
      <img
        :src="clientDeal.mainIcon"
        :alt="clientDeal.eventName"
        class="size-[88px] object-cover"
      >

      <div class="black-stroke-white-text-2 font-bold text-base text-center">
        {{ clientDeal.eventName }}
      </div>

      <div class="mt-1 text-red-danger text-xs flex items-center gap-1.5">
        <Clock4Icon class="size-3 mt-0.5" />
        <div class="red-stroke-black-text min-w-[68px] font-pilat text-xs font-bold">
          {{ formatDuration(countdownForEventEnd) }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.red-stroke-black-text {
	color: #000;
	-webkit-text-stroke-width: 2px;
	-webkit-text-stroke-color: #E8405F;
	paint-order: stroke fill;
}
</style>

